import {
  Component,
  ElementRef,
  Renderer2,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteConstants } from 'src/app/constants/route-constants';
import { ApiEndPoints } from 'src/app/constants/web-constants';
import { AuthenticationInterface } from 'src/app/models/auth/authentication-interface';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { CommonService } from 'src/app/services/common/common.service';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';
import { WebServiceMethod } from 'src/app/services/web/web-method';
import { WebServiceModel } from 'src/app/services/web/web-service-model';
import { WebService } from 'src/app/services/web/web.service';
import { UndefinedNullableString } from 'src/app/type-alias';

@Component({
  selector: 'app-two-factor-authenticate',
  templateUrl: './two-factor-authenticate.component.html',
  styleUrl: './two-factor-authenticate.component.css',
})
export class TwoFactorAuthenticateComponent implements AfterViewInit {
  otpValues: string[] = ['', '', '', '', '', ''];
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;
  errorString: UndefinedNullableString;
  queryParams: any;
  token: string = '';
  slug:string = ''
  isSubmitting=false

  constructor(
    private renderer: Renderer2,
    private authService: AuthserviceService,
    private webService: WebService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngAfterViewInit() {
    // Focus on the first input when the component is initialized
    this.focusInput(0);
    this. get_query_params();
    // Attach paste event listener manually to each input field
    this.otpInputs.forEach((otpInput, index) => {
      this.renderer.listen(otpInput.nativeElement, 'paste', (event: ClipboardEvent) => this.onPaste(event, index));
    });
  }
  onKeyDown(event: any, index: number) {
    // Allow only numeric keys and exclude control keys
    if (/^\d$/.test(event.key)) {
      event.preventDefault();
      this.otpValues[index] = event.key;
      this.focusNextInput(index);
    } else if (event.key === 'Backspace' && index > 0) {
      event.preventDefault();
      this.otpValues[index] = '';
      this.focusPreviousInput(index);
    }
  }

  private focusInput(index: number) {
    if (this.otpInputs && index >= 0 && index < this.otpInputs.length) {
      this.renderer
        .selectRootElement(this.otpInputs.toArray()[index].nativeElement)
        .focus();
    }
  }

  private focusNextInput(index: number) {
    this.focusInput(index + 1);
  }

  private focusPreviousInput(index: number) {
    this.focusInput(index - 1);
  }

  loginAdmin() {
    this.authService.setLoginCredentials(AppSessionStorageService.auth);
  }

  async get_query_params() {
    return new Promise<void>((resolve, reject) => {
      this.route.queryParams.subscribe(async (queryParams: any) => {
        try {
          // Access the names and values dynamically
          const decodedTokenParam = decodeURIComponent(
            queryParams['token']);
          const decodedSlugParam = decodeURIComponent(
            queryParams['slug']);
          this.queryParamProcessor(queryParams,decodedTokenParam,decodedSlugParam);
          resolve();
        } catch (error) {
          console.error('Error during decryption:', error);
          reject(error);
        }
      });
    });
  }

  queryParamProcessor(queryParams:any,decodedTokenParam:string,decodedSlugParam:string){
    if(queryParams['token']){
      this.token = decodedTokenParam;
    }else{
      this.token = AppSessionStorageService.twoFactorToken;
    }
    if(queryParams['slug']){
      this.slug = decodedSlugParam;
    }
    else{
      this.slug = AppSessionStorageService.twoFactorSlug;
    }
    return null
  }

  async onSubmit() {
    // /authenticate/otp
    this.isSubmitting=true
    const otp = this.otpValues.join('');
    if (!/^\d+$/.test(otp) && otp) {
      this.errorString = 'ONLY DIGITS ALLOWED';
      this.isSubmitting=false
      return
    }
    if (otp.length != 6) {
      this.errorString = 'INAVLID DIGITS OR EMPTY DIGITS';
      this.isSubmitting=false
      return
    }
    if(!this.token || this.token == undefined){
      this.token = AppSessionStorageService.twoFactorToken;
    }
    if(!this.slug || this.slug == undefined){
      this.slug = AppSessionStorageService.twoFactorSlug;
    }
    const payload = { otp: otp,token:this.token,slug:this.slug};
    const response = await this.webService.single<AuthenticationInterface>(
      new WebServiceModel(
        ApiEndPoints.OTP_AUTHENTICATE,
        WebServiceMethod.Post,
        payload
      )
    );
    if (response.success && response.data) {

      this.authService.setLoginCredentials(response.data)
    } else {
      this.errorString = 'UNAUTHORISED ACCESS';
      setTimeout(() => {
        localStorage?.clear();
        sessionStorage?.clear();
        this.router.navigate([RouteConstants.SIGNIN], { replaceUrl: true });
      }, 500); 
    }
    this.isSubmitting=false
    return null
  }

  onPaste(event: ClipboardEvent, index: number): void {
    event.preventDefault(); // Stop default paste behavior
  
    const pastedText = event.clipboardData?.getData('text')?.trim() || '';
    if (!pastedText) return;
  
    // Extract only digits from the pasted text
    const digits = pastedText.replace(/\D/g, '').split('');
  
    // Start filling OTP inputs from the first index (0)
    for (let i = 0; i < digits.length && i < this.otpValues.length; i++) {
      this.otpValues[i] = digits[i];
    }
  
    // Move focus to the next available input after the last filled one
    setTimeout(() => {
      const nextIndex = Math.min(digits.length, this.otpValues.length - 1);
      this.focusInput(nextIndex);
    }, 0);
  }
  
  
  
  
}
